import { useLocation } from 'react-router-dom';

export const carePortalPages = [
  'calls',
  'docket',
  'guides',
  'hospitalizations',
  'member-list',
  'members',
  'training-admin',
];

export type Page = (typeof carePortalPages)[number];

export const useCurrentPage = (): Page => {
  const location = useLocation();

  const page = (location.pathname || '/').split('/')[1] || '';
  return page as Page;
};
